import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from 'vue'
import { useRoute } from 'vue-router'
import i18n from '@/lang/i18n'


export default /*@__PURE__*/_defineComponent({
  __name: 'VehicleTabs',
  setup(__props) {

const route = useRoute()
const id = computed(() => route.params.id || null)
const formRoute = { name: 'VehicleForm', params: { id: id?.value } }
const installRoute = { name: 'VehicleInstall', params: { id: id?.value } }
const hasId = computed(() => !!id.value)

const activeTab = computed(() => {
  if (route.name === 'VehicleInstall') { 
    return 'install'
  }
  return 'form'
})


return (_ctx: any,_cache: any) => {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!

  return (hasId.value)
    ? (_openBlock(), _createBlock(_component_v_tabs, {
        key: 0,
        modelValue: activeTab.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeTab).value = $event)),
        "bg-color": "grey-lighten-4"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_tab, {
            to: formRoute,
            value: "form"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.vehicles.title.edit')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_tab, {
            to: installRoute,
            value: "install"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.vehicleInstall.title')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]))
    : _createCommentVNode("", true)
}
}

})